import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { PortfolioSite } from '../api/portfolioApi';
import type { Entity, EntityConnection } from '../../services/apiService';

export interface SiteState {
  sitesByPortfolio: Record<string, PortfolioSite[]>;
  currentSite: PortfolioSite | null;
  // Entities and connections for the current site
  entities: Entity[];
  connections: EntityConnection[];
  isLoadingEntities: boolean;
  isLoadingConnections: boolean;
}

const initialState: SiteState = {
  sitesByPortfolio: {},
  currentSite: null,
  entities: [],
  connections: [],
  isLoadingEntities: false,
  isLoadingConnections: false,
};

const siteSlice = createSlice({
  name: 'site',
  initialState,
  reducers: {
    setSitesForPortfolio: (
      state,
      action: PayloadAction<{ portfolioId: string; sites: PortfolioSite[] }>
    ) => {
      const { portfolioId, sites } = action.payload;
      state.sitesByPortfolio[portfolioId] = sites;
    },
    setCurrentSite: (state, action: PayloadAction<PortfolioSite | null>) => {
      state.currentSite = action.payload;
      // Clear entities and connections when site changes
      if (state.currentSite?.site_id !== action.payload?.site_id) {
        state.entities = [];
        state.connections = [];
      }
    },
    setEntities: (state, action: PayloadAction<Entity[]>) => {
      state.entities = action.payload;
    },
    setConnections: (state, action: PayloadAction<EntityConnection[]>) => {
      state.connections = action.payload;
    },
    setLoadingEntities: (state, action: PayloadAction<boolean>) => {
      state.isLoadingEntities = action.payload;
    },
    setLoadingConnections: (state, action: PayloadAction<boolean>) => {
      state.isLoadingConnections = action.payload;
    },
    resetSites: (state) => {
      state.sitesByPortfolio = {};
      state.currentSite = null;
      state.entities = [];
      state.connections = [];
      state.isLoadingEntities = false;
      state.isLoadingConnections = false;
    },
  },
});

export const {
  setSitesForPortfolio,
  setCurrentSite,
  setEntities,
  setConnections,
  setLoadingEntities,
  setLoadingConnections,
  resetSites,
} = siteSlice.actions;

export default siteSlice.reducer;


